// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SearchProgressBar__SearchProgressBar___2ADAu{background-color:#4a4a4a;border-radius:5px;padding:5px 5px 0;position:fixed;right:0;top:7%;z-index:10000}.SearchProgressBar__SearchProgressBarText___IKGUU{color:#fff;padding-left:27px}.SearchProgressBar__Progress___2CZ-r{padding-top:5px}.SearchProgressBar__Wait___3RJdN{display:flex;margin:8px}.SearchProgressBar__WaitSpinner___lnw89{margin-top:2px}.SearchProgressBar__WaitText___1k6XC{display:flex;font-size:12px;margin-left:8px}", ""]);
// Exports
exports.locals = {
	"SearchProgressBar": "SearchProgressBar__SearchProgressBar___2ADAu",
	"SearchProgressBarText": "SearchProgressBar__SearchProgressBarText___IKGUU",
	"Progress": "SearchProgressBar__Progress___2CZ-r",
	"Wait": "SearchProgressBar__Wait___3RJdN",
	"WaitSpinner": "SearchProgressBar__WaitSpinner___lnw89",
	"WaitText": "SearchProgressBar__WaitText___1k6XC"
};
module.exports = exports;
